<template>
  <div v-html="parseHtmlFromContent(content)">
  </div>
</template>

<script>

export default {
  name: 'message_text',
  props: [
    'senderType', 'messageType', 'content', 'fontStyle'
  ],
  computed: {
  },
  methods: {
    parseHtmlFromContent (content) {
      const jsonContent = JSON.parse(content)
      return jsonContent.text
    }
  }
}
</script>

<style>
  .msgLink a {
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/webchat/message/fragments/message_html.vue